import { type CustomerModelCloudConnectModel } from "@doitintl/cmp-models";

import { S3BucketNameRegex } from "../../../Pages/Customer/SaaSConsoleOnboarding/AWS/consts";
import { type Customer } from "../../../types";

interface AwsCloudConnectLinkParams {
  customer: Customer;
  cloudConnect?: CustomerModelCloudConnectModel;
  callbackUrl?: string;
}

export const getAwsCloudConnectSettingsLink = ({ customer, cloudConnect, callbackUrl }: AwsCloudConnectLinkParams) => {
  let base = `/customers/${customer.id}/integrate/aws`;

  if (cloudConnect) {
    base += `/${cloudConnect.accountId}`;
  }

  if (callbackUrl) {
    base += `?callbackUrl=${encodeURIComponent(callbackUrl)}`;
  }

  return base;
};

export const isBucketNameValid = (bucketName: string): boolean => S3BucketNameRegex.test(bucketName);
